export default function (value) {
  const validDate = new Date(value);
  return !!value && validDate instanceof Date && !isNaN(validDate);
}
